module.exports = __webpack_public_path__ + "s2.no2.769ce294.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s2.no2.jpg
// module id = /OHF
// module chunks = 0